import { SmmOrders } from '@apis/index'
import { outlinestore } from '@assets/icons'
import Column from '@components/column'
import { StatusTag } from '@components/status/style'
import Table from '@components/table'
import Title from '@components/title'
import { RootState } from '@store/index'
import { Helper } from '@utils/index'
import React, { Fragment, useState } from 'react'
import { useSelector } from 'react-redux'

const SmmOrderHistory = () => {
  const {
    items: orders,
    totalItems,
    totalPages,
    loading,
  } = useSelector((state: RootState) => state.smmOrders)
  const [page, setPage] = useState(1)
  const [searchTerm, setSearchTerm] = useState('')

  const data = orders.map((order) => ({
    id: order.id,
    userName: order.user?.name ?? '-',
    userEmail: order.user?.email ?? '-',
    serviceName: order.serviceName,
    link: order.link,
    quantity: order.quantity,
    rate: order.rate,
    points: order.points,
    status: order.status,
    createdAt: order.createdAt ? order.createdAt.split('T')[0] : '-',
  }))

  const columns = [
    {
      title: 'User',
      key: 'user',
      render: (item) => (
        <Column stylecolumn="row-gap:2px">
          <p>{item.userName}</p>
          <p style={{ color: 'gray', fontSize: '12px' }}>{item.userEmail}</p>
        </Column>
      ),
    },
    { title: 'Service', key: 'serviceName' },
    {
      title: 'Link',
      key: 'link',
      render: (item) => (
        <a
          href={item.link}
          target="_blank"
          rel="noreferrer"
          style={{ wordBreak: 'break-all' }}
        >
          {item.link}
        </a>
      ),
    },
    { title: 'Quantity', key: 'quantity' },
    { title: 'Rate', key: 'rate' },
    { title: 'Points Spent', key: 'points' },
    {
      title: 'Status',
      key: 'status',
      render: (item) => {
        const { text, bg } = Helper.getStatusColor(item.status)
        return (
          <StatusTag textColor={text} bgColor={bg}>
            {item.status}
          </StatusTag>
        )
      },
    },
    { title: 'Date', key: 'createdAt' },
  ]

  const fetchOrders = async (search = '') => {
    try {
      await SmmOrders.list({
        state: 'smmOrders',
        params: {
          page,
          limit: 30,
          ...(search && { search }),
        },
      })
    } catch (error) {
      console.error(error)
    }
  }

  React.useEffect(() => {
    setPage(1)
  }, [searchTerm])

  React.useEffect(() => {
    fetchOrders(searchTerm)
  }, [page, searchTerm])

  return (
    <Fragment>
      <Column>
        <Title textone="Store Management >" texttwo="SMM Order History" />
        <Table
          onSearchChange={setSearchTerm}
          loading={loading}
          onPageChange={setPage}
          totalItems={totalItems}
          totalPages={totalPages}
          pageControlled={page}
          itemsPerPage={30}
          data={data}
          columns={columns}
          searchKeys={['userName', 'userEmail', 'serviceName']}
          text="SMM order history"
          icon={outlinestore}
        />
      </Column>
    </Fragment>
  )
}

export default SmmOrderHistory
